import { forwardRef } from 'react';

import { nullNoop } from 'utils/noop';

export const LoyaltyRewardsBalance = forwardRef<HTMLDivElement>(nullNoop);
